import { useMemo } from 'react';
import { TooltipProvider } from '~/components/ui/tooltip';
import { visibleMenu } from '~/lib/menu';
import { useHasAccess } from '~/lib/auth/use-has-access';
import { useMenuFeatures } from '~/hooks/use-menu-features';
import { SidebarSection } from './sidebar-section';
import { SidebarFooter } from './sidebar-footer';

/**
 * Left navigation rail. Width is driven by `--sidebar-width` on the shell grid
 * (220px expanded / 64px collapsed). Sections scroll; the footer sticks to the
 * bottom. What is visible comes from `visibleMenu` — the same rule the command
 * palette applies, so the two surfaces cannot disagree about what exists.
 */
export function Sidebar() {
	const hasAccess = useHasAccess();
	const hasFeature = useMenuFeatures();
	const visibleSections = useMemo(() => visibleMenu(hasAccess, hasFeature), [hasAccess, hasFeature]);

	return (
		<TooltipProvider delayDuration={0}>
			<aside className="flex h-full flex-col overflow-hidden border-r border-border-subtle bg-elevated">
				<nav className="flex flex-1 flex-col gap-0 overflow-y-auto p-2">
					{visibleSections.map(section => (
						<SidebarSection key={section.id} section={section} />
					))}
				</nav>
				<SidebarFooter />
			</aside>
		</TooltipProvider>
	);
}
